<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesPrdPpHeaderResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" ref="emTable"
                        withCustomRowActions :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @linkClick="whenLinkClick">
                <template #left-header>
                  <!--                  <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-down"-->
                  <!--                             :disabled="actionDisabled('selectOne')"-->
                  <!--                             custom-label="调整计划开始时间"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="forecastBeginTimeAdjust()"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <!--                  <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-arrow-up"-->
                  <!--                             :disabled="actionDisabled('selectOne')"-->
                  <!--                             custom-label="调整计划结束时间"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="forecastFinishTimeAdjust()"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <em-button type="check" custom-icon="fa fa-fw fa-lg fa-link"
                             :disabled="actionDisabled('select')"
                             custom-label="关联父工单"
                             show-name
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="findParent()"
                             :busy="isFindingParent"
                  >
                  </em-button>
                  <em-button type="import"
                             custom-label="标准套工单替换"
                             :disabled="actionDisabled('select') || !virtualReplaceEnable"
                             custom-icon="fa fa-fw fa-lg fa-refresh"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             show-name
                             :busy="setDateBatch"
                             @click="ppHeaderExchange"
                  >
                  </em-button>
                  <em-button type="import"
                             custom-label="排产"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :busy="onScheduling"
                             v-b-modal.modal-schedule
                  >
                  </em-button>
                  <em-button type="import"
                             custom-label="批量设置时间"
                             custom-icon="fa fa-fw fa-lg fa-arrow-down"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :busy="setDateBatch"
                             v-b-modal.modal-setBatch
                  >
                  </em-button>
                  <!--                  <em-button type="export"-->
                  <!--                             custom-label="倒排产"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="scheduling_desc()"-->
                  <!--                             :busy="onScheduling_desc"-->
                  <!--                             confirm-text="确定要试着倒排产么？"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <!--                  <em-button type="view"-->
                  <!--                             custom-label="查看当前排产结果"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="getCurrentScheduling()"-->
                  <!--                             :busy="viewScheduledResult"-->
                  <!--                  >-->
                  <!--                    &lt;!&ndash;                             v-api-permission="['%/sith-mes/sithMesPrdPpHeader/scheduling','edit']"&ndash;&gt;-->
                  <!--                  </em-button>-->
                  <!--                  <em-button type="save"-->
                  <!--                             custom-label="保存排产结果"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="saveScheduledResult()"-->
                  <!--                             :busy="onSaving"-->
                  <!--                             confirm-text="确定要保存当前排产结果么？"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <em-button type="save"
                             custom-label="baseline"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="setBaseline()"
                             :busy="onSetBaseline"
                             show-name
                             confirm-text="确定要设置baseline么？"
                  >
                  </em-button>
                  <em-button type="cancel"
                             custom-label="清理排产结果"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="clearScheduledResult()"
                             :busy="onClearing"
                             confirm-text="确定要清理掉选中工单的排产结果么？如未选中任何工单则会清理所有未锁定的排产结果"
                  >
                  </em-button>
                  <em-button type="check" custom-icon="fa fa-fw fa-lg fa-lock"
                             :disabled="actionDisabled('select')"
                             custom-label="锁定"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="lock()"
                  >
                  </em-button>
                  <em-button type="cancel" custom-icon="fa fa-fw fa-lg fa-unlock"
                             :disabled="actionDisabled('select')"
                             custom-label="解锁"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="unlock()"
                  >
                  </em-button>
                  <em-button type="issue"
                             :disabled="actionDisabled('select')"
                             custom-label="下发"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="issue()"
                  >
                  </em-button>
                  <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-print"
                             :disabled="actionDisabled('select')"
                             custom-label="物料码打印"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="print()"
                  >
                  </em-button>
                  <em-button
                      type="uploadFile"
                      class="btn btn-outline-primary btn-sm"
                      :disabled="actionDisabled('selectOne')"
                      custom-label="上传附件"
                      :busy="saveAttachmentLoading"
                      @click="openAttachmentModal">
                  </em-button>
                  <em-button
                      type="edit" custom-icon="fa fa-fw fa-lg fa-print"
                      class="btn btn-outline-primary btn-sm"
                      :disabled="actionDisabled('selectOne')"
                      custom-label="图纸打印"
                      @click="getFileOptions()">
                  </em-button>
                  <em-button type="save"
                             custom-label="发起转交"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :disabled="actionDisabled('selectOne')"
                             @click="createDeliveryTask()"
                             :busy="onDelivery"
                             show-name
                             confirm-text="确定发起转交？"
                  >
                  </em-button>
                  <em-button type="save" custom-icon="fa fa-fw fa-lg fa-tasks"
                             :disabled="actionDisabled('selectOne')"
                             custom-label="发起退库"
                             :showName="true"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="openStockReturnDialog()"
                  >
                  </em-button>
                  <em-button type="save" custom-icon="fa fa-fw fa-lg fa-tasks"
                             :disabled="actionDisabled('select')"
                             custom-label="发起综合业务"
                             :showName="true"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="openComprehensiveBusinessDialog()"
                  >
                  </em-button>
                  <!--                  <em-button type="issue"-->
                  <!--                             :disabled="actionDisabled('select')"-->
                  <!--                             custom-label="测试发送消息"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="sendMessage()"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <!--                  <em-button type="issue"-->
                  <!--                             :disabled="actionDisabled('select')"-->
                  <!--                             custom-label="测试取消订阅"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="unsubscribe()"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                  <!--                  <em-button type="edit"-->
                  <!--                             custom-label="测试promise"-->
                  <!--                             v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                             @click="apiTest()"-->
                  <!--                  >-->
                  <!--                  </em-button>-->
                </template>
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-label="跳转工序信息"
                               custom-icon="fa fa-list-ul"
                               @click="gotoChild(row)">
                    </em-button>
                    <em-button type="gotoChildComponent"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-label="跳转组件信息"
                               custom-icon="fa fa-cubes"
                               @click="gotoComponent(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <b-modal id="modal-schedule" title="排产" hide-footer>
      <b-form @submit="handleScheduleSubmit" @reset="handleScheduleReset">
        <b-form-group
            id="schedulingStrategy-group"
            label="排产策略:"
            label-for="input-schedulingStrategy"
            invalid-feedback="必须选择排产策略">
          <b-form-select id="input-schedulingStrategy" v-model="schedulingForm.schedulingStrategy"
                         :options="schedulingStrategyOptions"
                         required></b-form-select>
        </b-form-group>
        <b-form-group
            id="beginTimePicker"
            label="时间:"
            label-for="input-beginTimePicker">
          <el-date-picker
              v-model="beginTimeValue"
              align="right"
              type="date"
              placeholder="选择开始日期">
          </el-date-picker>
          <el-date-picker
              v-model="endTimeValue"
              align="right"
              type="date"
              placeholder="选择结束日期">
          </el-date-picker>
        </b-form-group>
        <!--                <b-form-group-->
        <!--                    id="synchronize-group"-->
        <!--                    label="同步生产:"-->
        <!--                    label-for="input-synchronize">-->
        <!--                    <el-switch-->
        <!--                        style="display: block"-->
        <!--                        v-model="schedulingForm.synchronize"-->
        <!--                        active-color="#13ce66"-->
        <!--                        inactive-color="#ff4949"-->
        <!--                        active-text="同步">-->
        <!--                    </el-switch>-->
        <!--                </b-form-group>-->
        <b-form-group
            id="basedSap-group"
            label="基于sap:"
            label-for="input-basedSap">
          <el-switch
              style="display: block"
              v-model="schedulingForm.bornLineBasedSap"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="最早开始">
          </el-switch>
          <el-switch
              style="display: block"
              v-model="schedulingForm.deadLineBasedSap"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="最晚完成">
          </el-switch>
        </b-form-group>
        <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">排产</b-button>
          <b-button type="reset" variant="danger">取消</b-button>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="modal-setBatch" title="批量设置" hide-footer>
      <b-form @submit="handleSetBatchSubmit" @reset="handleSetBatchReset">
        <b-form-group
            id="setBatch-group"
            label="修改:"
            label-for="input-setDateBatch"
            invalid-feedback="必须选择要修改的内容">
          <b-form-select id="input-setBatchType" v-model="setBatchType"
                         :options="setBatchTypeOptions"
                         required></b-form-select>
        </b-form-group>
        <b-form-group
            id="setBatch-timePicker"
            label="时间:"
            label-for="input-timePicker"
            invalid-feedback="必须填写人数">
          <!--          <b-form-input id="input-headCountState" v-model="saveForm.headCount" placeholder="请输入人数" type="number"-->
          <!--                        required></b-form-input>-->
          <el-input-number v-if="setBatchType===5" v-model="setBatchForm.priority"
                           placeholder="填写优先级"
          ></el-input-number>
          <el-input v-else-if="setBatchType===6" v-model="setBatchForm.activity"
                    placeholder="填写activityId"
          ></el-input>
          <el-date-picker v-else
                          v-model="setBatchForm.adjustDate"
                          type="datetime"
                          placeholder="选择日期时间">
          </el-date-picker>
        </b-form-group>
        <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">确定</b-button>
          <b-button type="reset" variant="danger">取消</b-button>
        </b-row>
      </b-form>
    </b-modal>
    <el-dialog
        :title="adjustDialogTitle"
        :center="true"
        width="30%"
        :visible.sync="adjustDialogVisible">
      <div class="col center-name dialog-text">
        <div class="row">
          <div class="col" style="padding-left: 10%">
            <div class="row">
              <el-date-picker
                  class="col mt-1"
                  v-model="forecastDate"
                  type="datetime"
                  :placeholder="adjustDatePickerPlaceHolder"
                  :clearable="false"
                  :editable="false">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="adjustDialogVisible = false">取 消</el-button>
                <el-button :loading="submitLoading" type="primary" @click="submitChange">确 定</el-button>
            </span>
    </el-dialog>
    <el-dialog title="图纸打印" :visible.sync="printPictureDialogVisible" :close-on-click-modal='false' append-to-body
               @close='clearPrintForm'>
      <el-form :model="printPicture" ref="printPicture" label-width="auto" size="mini" :inline="true">
        <el-row>
          <el-col :span="6">
            <el-form-item label="图纸名">
              <el-select v-model="printPicture.fileName" multiple placeholder="请选择">
                <el-option v-for="item in fileOptions" :key="item.value" :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="工位">
              <el-input v-model="printPicture.location"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="需求人">
              <el-input v-model="printPicture.requester"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="时间">
              <el-date-picker v-model="printPicture.time" type="datetime" placeholder="选择日期时间"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printPictureDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="notifyPrinter()">通知打印员</el-button>
      </div>
    </el-dialog>
    <!-- 选择组件发起退库 -->
    <el-dialog title="选择退库物料" width="50%" :visible.sync="stockReturnVisible" :close-on-click-modal='false' append-to-body
               @close='closeStockReturn'>
      <el-table :header-cell-class-name="addStar" :data="componentList" ref="componentTable" style="width:100%"
                max-height="285px" @selection-change="changeSelectedComponents">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="工单号" prop="orderNumber"></el-table-column>
        <el-table-column label="物料号" prop="materialNumber"></el-table-column>
        <el-table-column label="物料描述" prop="materialDescription"></el-table-column>
        <el-table-column label="退库数量" prop="quantity">
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.quantity" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="位置" prop="materialLocation">
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.materialLocation" size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="stockReturnVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="noComponentSelect" @click="createStockReturn()">确认</el-button>
      </div>
    </el-dialog>
    <!--      上传附件-->
    <ReBModal header="上传附件"
              @ok="submitAttachmentChange"
              ref="uploadAttachment">
      <multi-attachment class="w-100"
                        :query-api="attachmentQueryApi"
                        @loading="attachmentLoading"
                        @idsChanged="changeAttachmentIds"
                        :attachment-ids="attachmentIds"></multi-attachment>
    </ReBModal>

    <em-modal-entity-selector ref="virtualHeaderSelect" check-enable
                              @checkFinish="whenCheckFinish"></em-modal-entity-selector>

    <drawing-select-in-bom ref="drawingSelect"></drawing-select-in-bom>
    <bom-tree-modal ref="bomTreeModal"></bom-tree-modal>
          <comprehensive-business :selectedOrderCode="this.selectIds" :comprehensiveBusinessDialogVisible="comprehensiveBusinessVisible"
                                  :selected-items="this.checkedItemsRows()" is-from-order @change = "change">

          </comprehensive-business>


  </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-09-30 18:07:13

import moment from "moment";
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DrawingSelectInBom from "@/views/sithMesII/pds/stuffs/DrawingSelectInBom.vue";
import BomTreeModal from "@/components/bom/BomTreeModal.vue";
import ComprehensiveBusiness from "@/components/SithMes/ComprehensivebusinessForm.vue";
import EmVerificationCode from "@/components/em/login/VerificationCode.vue";

export default {
  name: "sithMesPrdPpHeaderListView",
  components: {EmVerificationCode, BomTreeModal, DrawingSelectInBom, MultiAttachment, ReBModal, ComprehensiveBusiness},
  mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      saveRemark: '',
      onScheduling: false,
      setDateBatch: false,
      isFindingParent: false,
      onClearing: false,
      setBatchType: 1,
      viewScheduledResult: false,
      onSaving: false,
      onSetBaseline: false,
      onDelivery: false,
      adjustDialogTitle: "",
      adjustDatePickerPlaceHolder: "",
      adjustDialogVisible: false,
      adjustType: 1,
      forecastDate: '',
      submitLoading: false,
      ////////////////////////////////////websocket 测试
      subscribeItemA: {
        id: "testA",
        topic: "test",
        callback: (payload) => {
          console.log("A:" + payload)
        }
      },
      subscribeItemB: {
        id: "testB",
        topic: "test",
        callback: (payload) => {
          console.log("B:" + payload)
        }
      },
      //对应后端：PrdPpSchedulingStrategyEnum
      schedulingStrategyOptions: [
        {value: '2', text: '正排'},
        {value: '3', text: '倒排'}
      ],
      setBatchTypeOptions: [
        {value: 1, text: '计划开始时间'},
        {value: 2, text: '计划结束时间'},
        {value: 3, text: '最早开始时间'},
        {value: 4, text: '最晚完成时间'},
        {value: 5, text: '优先级'},
        {value: 6, text: 'activityId'},
      ],
      schedulingForm: {
        headerIds: '',
        schedulingStrategy: 2,
        beginTime: null,
        endTime: null,
        synchronize: false,
        bornLineBasedSap: false,
        deadLineBasedSap: false
      },
      setBatchForm: {
        headerIds: '',
        adjustDate: null,
        priority: 1,
        activity: ''
      },
        comprehensiveBusinessVisible : false,
      // pickerOptions: {
      //   shortcuts: [{
      //     text: '一个月',
      //     onClick(picker) {
      //       const start = new Date();
      //       const end = new Date();
      //       end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '三个月',
      //     onClick(picker) {
      //       const start = new Date();
      //       const end = new Date();
      //       end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '半年',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '一年',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '两年',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 2);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }]
      // },
      // value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      beginTimeValue: '',
      endTimeValue: '',
      attachmentIds: '',
      saveAttachmentLoading: false,
      printPictureDialogVisible: false,
      fileOptions: [],
      printPicture: {
        id: '',
        fileName: [],
        location: '',
        requester: '',
        time: ''
      },
      stockReturnVisible: false,
      componentList: [],
      selectedComponents: [],

      ableToFilterDrawing: false
    }
  },
  computed: {
    modelName() {
      return "sithMesPrdPpHeader"
    },
    showForm(isChoose) {
      return (this.isChooseOutdoor * this.isChooseTransport * this.isChooseDelivery * this.isChooseTransferTicket) %isChoose ===0 ;
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      // return this.$refs.emTable.checkedItems.join(",")
      return this.$store.state[this.modelName]["checkedItems"].join(",")
    },
    entityBaseUrl() {
      return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      // return this.$refs.emTable.checkedItems
      return this.$store.state[this.modelName]["checkedItems"]
    },
    attachmentQueryApi() {
      return `${process.env.VUE_APP_SITHMES_PRD_URL}/${this.modelName}/getAttachmentList`;
    },
    //虚拟工单替换是否可用
    virtualReplaceEnable() {
      return this.virtualReplaceProjectCode != null;
    },
    virtualReplaceProjectCode() {
      let projectCode = null;
      for (let item of this.$refs.emTable.checkedItemsRows) {
        let code = item.projectCode;
        if (code == null) {
          return null;
        }
        if (projectCode == null) {
          projectCode = code;
        } else if (code !== projectCode) {
          return null;
        }
      }
      return projectCode;
    },
    noComponentSelect() {
      return this.selectedComponents.length === 0;
    }
  },
  watch: {
    beginTimeValue(newValue) {
      this.schedulingForm.beginTime = moment(newValue).format(this.$t("em.datetime.format.viewMode"))
    }, endTimeValue(newValue) {
      this.schedulingForm.endTime = moment(newValue).format(this.$t("em.datetime.format.viewMode"))
    }
  },
  mounted() {
    // this.subscribe()
    // this.promiseC(true)
    if (this.$store.state.calendarShift.saveResult) {
      this.saveScheduledResult()
    }

    //打印图纸时，打印员自动跳转到需要打印的工单
    if (this.$route.query.id) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
    }
    //从上工页面跳转过来，卡物料号查询
    if (this.$route.query.material) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', this.$route.query.material);
    }
    this.$refs.emListFilter.doQuery();
    this.checkUserRole();
  },
  // destroyed() {
  //   this.unsubscribe()
  // },
  methods: {
      checkedItemsRows() {
          //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
          // return this.$refs.emTable.checkedItemsRows
          return this.$store.state[this.modelName]['rows'].filter(f => this.checkedItems.includes(f.id));
      },
    handleSetBatchSubmit(event) {
      event.preventDefault()
      this.setDateBatch = true
      //给选中记录id赋值
      this.setBatchForm.headerIds = this.selectIds
      if (this.setBatchType < 5)
        this.setBatchForm.adjustDate = moment(this.setBatchForm.adjustDate).format(this.$t("em.datetime.format.viewMode"))
      //调用api保存数据
      let api
      if (this.setBatchType === 1) {
        api = "/forecastBeginTimeBatch"
      } else if (this.setBatchType === 2) {
        api = "/forecastFinishTimeBatch"
      } else if (this.setBatchType === 3) {
        api = "/bornlineBatch"
      } else if (this.setBatchType === 4) {
        api = "/deadlineBatch"
      } else if (this.setBatchType === 5) {
        api = "/priorityBatch"
      } else if (this.setBatchType === 6) {
        api = "/activityBatch"
      }
      // Hide the modal manually
      this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}${api}`, this.setBatchForm)
          .then(response => {
            commonViewsUtil.showSuccess(this, "设置成功")
            this.$refs.emListFilter.doQuery()
          }).finally(() => this.setDateBatch = false);
      this.$nextTick(() => {
        this.$bvModal.hide('modal-setBatch')
      })
    },
    handleSetBatchReset() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-setBatch')
      })
    }, handleScheduleSubmit(event) {
      event.preventDefault()
      // alert(JSON.stringify(this.saveForm))
      //给选中记录id赋值
      this.schedulingForm.headerIds = this.selectIds
      this.scheduling()
      //调用api保存数据
      //todo 调用api保存数据
      // Hide the modal manually
      // this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/setActualLoc`, this.saveForm)
      //     .then(response => {
      //       commonViewsUtil.showSuccess(this, "设置成功")
      //       this.$refs.emListFilter.doQuery()
      //     })
      this.$nextTick(() => {
        this.$bvModal.hide('modal-schedule')
      })
    },
    handleScheduleReset() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-schedule')
      })
    },

      handleComprehensiveBusinessSubmit(event) {
          event.preventDefault()
          // alert(JSON.stringify(this.saveForm))
          //给选中记录id赋值
          this.schedulingForm.headerIds = this.selectIds
          this.scheduling()
          //调用api保存数据
          //todo 调用api保存数据
          // Hide the modal manually
          // this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/setActualLoc`, this.saveForm)
          //     .then(response => {
          //       commonViewsUtil.showSuccess(this, "设置成功")
          //       this.$refs.emListFilter.doQuery()
          //     })
          this.$nextTick(() => {
              this.$bvModal.hide('modal-schedule')
          })
      },
      handleComprehensiveBusinessReset() {
          this.$nextTick(() => {
              this.$bvModal.hide('modal-schedule')
          })
      },
    ////////promise测试
    apiTest() {
      //commonErrorHandle不传或者传的不是false，就会开启通用error处理
      this.$_emApiMixin_get("http:sfg", false)
          .then(() => console.log("api test then"))
          .catch((err) => console.log("api test catch", err))
          .finally(() => console.log("api test finally"))
    },
    promiseC(isOk) {
      this.promiseB(isOk).then(response => {
        console.log("promiseC then: " + response)
      }).catch(error => {
        console.log("promiseC catch: " + error)
      }).finally(() => {
        console.log("promiseC finally!")
      })
    },
    promiseB(isOk) {
      return new Promise((resolve, reject) => {
        console.log("promiseB 调用")
        this.promiseA(isOk)
            .then(response => resolve(response))
            .catch(error => {
              console.log("promiseB catch")
              return reject(error)
            });
      });
    },
    promiseA(isOk) {
      return new Promise((resolve, reject) => {
        console.log("promiseA 调用")
        if (isOk) {
          console.log("promiseA resolve")
          return resolve("promiseA resolve")
        } else {
          console.log("promiseA reject")
          return reject("promiseA reject")
        }
      })
    },
    ////////////////////////////////////websocket 测试
    sendMessage() {
      this.$webSocket.sendToBroadcast({topic: "test", data: "你好吗"})
    },
    subscribe() {
      this.$webSocket.subscribeToBroadcast(this.subscribeItemA)
      this.$webSocket.subscribeToBroadcast(this.subscribeItemB)
    },
    unsubscribe() {
      this.$webSocket.unsubscribeToBroadcast(this.subscribeItemA.id)
      this.$webSocket.unsubscribeToBroadcast(this.subscribeItemB.id)
    },
    disconnect() {
      this.$webSocket.disconnect()
    },
    ///////////////////////////////////////////////////////////////
    gotoChild(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesPrdPpOperation"
          , {prdPpHeaderIdFilter: row.id}
          , {prdPpHeaderId: row.id}, false, {})
    },
    gotoComponent(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesPrdPpComponent"
          , {orderNumberFilter: row.orderCode}
          , {orderNumber: row.orderCode}, false, {})
    },
    scheduling() {
      this.onScheduling = true;
      let url = `${this.entityBaseUrl}scheduling`;
      this.$_emApiMixin_post(url, this.schedulingForm)
          .then(response => {
            // commonViewsUtil.showSuccess(this, "排产成功")
            // this.$refs.emListFilter.doQuery()
            this.$store.commit('calendarShift/setSchedulingForm', this.schedulingForm);
            this.$store.dispatch('calendarShift/collectOriginData', response.data).then(() =>
                this.$router.push({
                  path: "/loadRate?showSave=true"
                })
            )

          }).then(() => {
        this.$_emCommonListMixin_needToRefresh = true
      }).finally(() => {
        this.onScheduling = false
      })
    },
    getCurrentScheduling() {
      this.viewScheduledResult = true
      let url = `${this.entityBaseUrl}currentScheduledResult`
      this.$_emApiMixin_get(url)
          .then(response => {
            // commonViewsUtil.showSuccess(this, "排产成功")
            // this.$refs.emListFilter.doQuery()
            this.$store.commit('calendarShift/setSchedulingForm', this.schedulingForm);
            this.$store.dispatch('calendarShift/collectOriginData', response).then(() =>
                this.$router.push({
                  path: "/loadRate?showSave=true"
                })
            )

          }).then(() => {
        this.$_emCommonListMixin_needToRefresh = true
      }).finally(() => this.viewScheduledResult = false)

    },
    saveScheduledResult() {
      this.onSaving = true
      let url = `${this.entityBaseUrl}saveScheduledResult?version=1`
      this.$_emApiMixin_post(url, {version: 1, remark: this.saveRemark})
          .then(response => {
            commonViewsUtil.showSuccess(this, "保存成功")
            this.$refs.emListFilter.doQuery()
            this.$store.commit('calendarShift/setSaveResult', false);
          }).then(
          this.$_emCommonListMixin_needToRefresh = true
      ).finally(() => this.onSaving = false)
    },
    clearScheduledResult() {
      this.onClearing = true
      let url = `${this.entityBaseUrl}clearScheduledResult?ids=${this.selectIds}`
      //todo:暂时固定传1，将来再看怎么弄
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "清理成功")
          }).finally(() => this.onClearing = false)
    },
    lock() {
      let url = `${this.entityBaseUrl}lock?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "锁定成功")
            this.$refs.emListFilter.doQuery()
          })
    },
    setBaseline() {
      let url = `${this.entityBaseUrl}setBaseline?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "设置baseline成功")
            this.$refs.emListFilter.doQuery()
          })
    },
    findParent() {
      this.isFindingParent = true
      let url = `${this.entityBaseUrl}fitParent?headerIds=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "关联父工单成功")
            this.$refs.emListFilter.doQuery()
            this.isFindingParent = false
          })
    },
    unlock() {
      let url = `${this.entityBaseUrl}unlock?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "解锁成功")
            this.$refs.emListFilter.doQuery()
          })
    },
    issue() {
      let url = `${this.entityBaseUrl}issue?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "下发成功")
            this.$refs.emListFilter.doQuery()
          })
    },
    print() {
      let url = `${this.entityBaseUrl}print?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            this.$router.push({
              name: "sithMesInventoryItemPrint",
              query: response.data,
            });
          })
    },
    actionDisabled(type) {
      if (this.checkedItems) {
        // 删除按钮在一条记录都没选的时候禁用
        if (type === "select") {
          // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
          return this.checkedItems && this.checkedItems.length === 0;
        }
        // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
        else if (type === "selectOne") {
          // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
          return this.checkedItems && this.checkedItems.length !== 1;
        }
      } else return false
    },
    forecastBeginTimeAdjust() {
      this.adjustDialogTitle = "调整工单计划开始时间"
      this.adjustDatePickerPlaceHolder = "计划开始时间"
      this.forecastDate = this.$store.state.sithMesPrdPpHeader['entity'].forecastBeginTime;
      this.adjustDialogVisible = true
    },
    forecastFinishTimeAdjust() {
      this.adjustDialogTitle = "调整工单计划结束时间"
      this.adjustDatePickerPlaceHolder = "计划结束时间"
      this.forecastDate = this.$store.state.sithMesPrdPpHeader['entity'].forecastFinishTime;
      this.adjustDialogVisible = true
    },
    submitChange() {
      // this.submitLoading = true;
      // let today = moment(new Date(this.currentDate)).format(
      //     this.$t("em.date.format.viewMode")
      // )
      // let date = moment(this.forecastDate).format(
      //     this.$t("em.date.format.viewMode")
      // )
      //如果时间没变化，也请求后端，因为有时间不变，只重新计算的需求
      // if (this.workCenters[this.dataIndex].id === this.targetWorkCenter && today === date) {
      //   this.$message({
      //     message: '没有改动！',
      //     type: 'warning'
      //   });
      //   this.submitLoading = false;
      //   return
      // }
      let self = this;
      let _api = `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpHeader")}/`
      let _requestBody = {}
      if (this.adjustDialogTitle === "调整工单计划开始时间") {
        _api += "/forecast-begin-time-adjust";
        _requestBody = {
          headerId: this.$store.state.sithMesPrdPpHeader['entity'].id,
          manualAdjustType: this.adjustType,
          forecastBeginTime: moment(this.forecastDate).format(
              this.$t("em.datetime.format.viewMode")
          )
        }
      } else {
        _api += "/forecast-finish-time-adjust";
        _requestBody = {
          headerId: this.$store.state.sithMesPrdPpHeader['entity'].id,
          manualAdjustType: this.adjustType,
          forecastFinishTime: moment(this.forecastDate).format(
              this.$t("em.datetime.format.viewMode")
          )
        }
      }
      this.$_emApiMixin_post(_api, _requestBody).then(request => {
        // this.submitLoading = false;
        if (request.status === 200) {
          self.dialogVisible = false;
          self.$message({
            message: '修改成功！',
            type: 'success'
          });
          self.$refs.emListFilter.doQuery();
        } else {
          self.$message({
            message: '修改失败！',
            type: 'error'
          });
        }
      })
      this.adjustDialogVisible = false
    },
    openAttachmentModal() {
      this.attachmentIds = this.$store.state.sithMesPrdPpHeader['entity'].attachments;
      this.$refs.uploadAttachment.showModal();
    },
    changeAttachmentIds(ids) {
      this.attachmentIds = ids;
    },
    submitAttachmentChange() {
      let checkedItem = this.checkedItems[0];
      this.saveAttachmentLoading = true;
      let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
      this.$_emApiMixin_put(api, {
        id: checkedItem,
        attachments: this.attachmentIds === undefined ? "" : this.attachmentIds
      }).then(() => {
        this.$message.success("保存成功");
        this.$refs.emListFilter.doQuery();
      }).finally(() => this.saveAttachmentLoading = false);
    },
    attachmentLoading(val) {
      this.$refs.uploadAttachment.changeLoading(val);
    },
    //虚拟工单替换
    ppHeaderExchange() {
      if (!this.virtualReplaceEnable) {
        this.$message.error("项目号必须相同");
        return;
      }
      this.$refs.virtualHeaderSelect.setCustomVuexConfig('sithMesPrdPpHeader', 'virtual', 15);
      this.$refs.virtualHeaderSelect.onlyShowModal();
      this.$nextTick(() => {
        this.$refs.virtualHeaderSelect.doSomethingWithFiler(filter => {
          console.log(filter)
          filter.$_emCustomVuexMixin_setFilterAttribute('prpCodeFilter', this.virtualReplaceProjectCode);
          filter.$_emCustomVuexMixin_setFilterAttribute('ppHeaderTypeInFilter', ['3']);
          filter.doQuery();
        });
      })
    },
    hasCode(value) {
      return value !== undefined && value != null && value !== '';
    },
    whenCheckFinish(ids) {
      if (this.hasCode(this.selectIds) && this.hasCode(ids)) {
        this.setDateBatch = true;
        this.$store.dispatch('api/post', {
          url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdPpHeader/virtualReplacement?headerIds=${this.selectIds}&virtualHeaderIds=${ids}`
        }).then(() => {
          this.$message.success("替换成功");
        }).finally(() => this.setDateBatch = false);
      }
    },
    clearPrintForm() {
      this.printPicture.fileName = [];
      this.printPicture.location = '';
      this.printPicture.requester = '';
      this.printPicture.time = '';
      this.$refs["printPicture"].resetFields();
    },
    getFileOptions() {
      this.fileOptions = [];
      this.printPictureDialogVisible = true;
      this.attachmentIds = this.$store.state.sithMesPrdPpHeader['entity'].attachments;
      this.printPicture.id = this.$store.state.sithMesPrdPpHeader['entity'].id;
      var url = process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/getAttachmentList" + "?attachmentIds=" + this.attachmentIds;
      this.$store.dispatch('api/get', {url: url}).then(response => {
        if (response.length > 0) {
          for (let item of response) {
            this.fileOptions.push({
              label: item.fileName,
              value: item.fileName
            })
          }
        }
      })
      this.$store.dispatch('api/get', {url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdPpHeader/getWorkLocation?headerId=${this.selectIds}`}).then(response => {
        this.$set(this.printPicture, 'location', response);
      })
    },
    notifyPrinter() {
      if (!this.printPicture.fileName.length) {
        this.$message.error("请选择要打印的图纸！");
      }
      let url = `${this.entityBaseUrl}notifyPrinter`;
      this.$_emApiMixin_post(url, this.printPicture)
          .then(() => {
            commonViewsUtil.showSuccess(this, "通知成功！");
            this.printPictureDialogVisible = false;
          })
    },
    createDeliveryTask() {
      this.onDelivery = true;
      let url = `${this.$_emApiMixin_entityBaseApi('sithMesInventoryDeliveryTask')}/createOrderDeliveryThroughPrdHeader?prdHeaderId=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "转交成功")
            this.$refs.emListFilter.doQuery()
            this.onDelivery = false;
          })
    },
    addStar(obj) {
      if (obj.columnIndex === 4 || obj.columnIndex === 5) {
        return 'star';
      }
    },
    openStockReturnDialog() {
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesPrdPpComponent")}/findComponentsByHeaderId?headerId=${self.checkedItems}`
      self.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              if (response.data instanceof Array) {
                self.componentList = response.data;
              }
              self.stockReturnVisible = true;
            } else {
              self.$message({
                message: "获取工单组件失败",
                type: "error",
              });
            }

          })
    },
      openComprehensiveBusinessDialog() {
          this.comprehensiveBusinessVisible = true;
      },
      change() {
          this.comprehensiveBusinessVisible = false;
      },
    closeStockReturn() {
      this.componentList = [];
      this.selectedComponents = [];
    },
    changeSelectedComponents(selection) {
      this.selectedComponents = selection;
    },
    createStockReturn() {
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi('sithMesInventoryStockReturn')}/createStockReturn`;
      this.$_emApiMixin_post(url, self.selectedComponents)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "发起退库成功",
                type: "success",
              });

              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "发起退库失败",
                type: "error",
              });
            }
          }).finally(() => {
        this.stockReturnVisible = false;
      })
    },
    whenLinkClick(key, row) {
      if (key === 'materialCode') {
        if (this.ableToFilterDrawing) {
          this.$refs.drawingSelect.showModal(row.materialCode, row.parentMaterial);
        } else {
          this.$refs.bomTreeModal.showModalV2(row.materialCode, row.parentMaterial);
        }
      }
    },
    checkUserRole() {
      this.$store.dispatch('api/post', {
        url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclRoleUser/isRoleByCode?code=drawing_filter_role"
      }).then(response => {
        if (response.data) {
          this.ableToFilterDrawing = true;
        }
      });
    },
  }
};
</script>

<style>
.el-table th.star > .cell::before {
  content: '*';
  color: red;
}
</style>
